import React, { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { PrimaryIdentificationProvider } from "./context/PrimaryIdentificationContext";
import { NetworkStatusProvider } from "./context/NetworkContext";
import {
  fetchConfigDetailsFromClientHost,
  loadLocalUser,
  watchForChatSDKEvents,
} from "./Simplify360Chat/Services/HWIframeBridge";
import { s360ConfigService } from "./Simplify360Chat/Services/S360Config";
import Simplify360Chat from "./Simplify360Chat/Simplify360Chat";

import "./App.css";
import uuid from "react-uuid";
import { removeCookieForContactDetails } from "./Simplify360Chat/Conversation/utils/ConversationUtils";

function App() {
  const appRef = useRef();

  const [user, setUser] = useState(null);
  const [chatMaximized, setChatMaximized] = useState(false);
  const [refresh, setRefresh] = useState(true);
  const [showDynamicForm, setShowDynamicForm] = useState(false);
  const [isConfigLoaded, setIsConfigLoaded] = useState(false); // New state
  function getAllCookieNames() {
    const cookies = document.cookie.split(";");
    const cookieNames = [];
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();

      const name = cookie.split("=")[0];
      cookieNames.push(name);
    }
    return cookieNames;
  }

  function removeAllCookies() {
    const cookieNames = getAllCookieNames();
    for (let i = 0; i < cookieNames.length; i++) {
      Cookies.remove(cookieNames[i]);
    }
  }
  useEffect(() => {
    function decodeBootPayload(b64) {
      try {
        // reverse of encodeBootPayload
        const json = decodeURIComponent(escape(atob(b64)));
        return JSON.parse(json);
      } catch {
        return null;
      }
    }

    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    const boot = hashParams.get("boot");
    const initialConfig = boot ? decodeBootPayload(boot) : null;

    s360ConfigService.setConfig(initialConfig);
    setRefresh((currentRefresh) => !currentRefresh);

    // use `initialConfig` to hydrate your app
  }, []);
  useEffect(() => {
    // fetchConfigDetailsFromClientHost();

    sessionStorage?.removeItem("subscribed");

    s360ConfigService.loadClientConfigFromToken();
    sessionStorage.setItem("handshaken", "false");
    watchForChatSDKEvents(
      { setChatMaximized, setRefresh, setShowDynamicForm },
      () => {}
    );
  }, []);
  function removeSessionAndLocalStorage() {
    localStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("userContext");
    localStorage.removeItem("FAQ_Article_Clicked");
  }
  useEffect(() => {
    // Set isConfigLoaded to true when s360ConfigService.config changes

    setTimeout(() => {
      setIsConfigLoaded(true);
      window.parent.postMessage(
        {
          source: "react-app-live-chat",
          type: "CONFIG_LOADED",
          payload: true,
        },
        "*"
      );
    }, 1400);
  }, [s360ConfigService.config]);

  const handleWidgetConfigCookie = (widgetConfigId) => {
    if (!widgetConfigId) return;

    const cookieName = `nextiva-identification-${widgetConfigId}`;

    const existingCookie = Cookies.get(cookieName);

    if (!existingCookie) {
      removeSessionAndLocalStorage(widgetConfigId);
      Cookies.set(cookieName, uuid(), {
        expires: 30,
        secure: true,
        sameSite: "None",
      });
    }
  };

  const handleWidgetOfflineHours = (widgetConfigId) => {
    if (!widgetConfigId) return;

    const cookieName = `nextiva-widget-working-hours-${widgetConfigId}`;

    const existingCookie = Cookies.get(cookieName);

    if (
      existingCookie &&
      existingCookie?.toString() !==
        s360ConfigService.config?.isCurrentWorkingHour?.toString()
    ) {
      removeCookieForContactDetails(widgetConfigId);
      removeSessionAndLocalStorage(widgetConfigId);
    }

    if (!existingCookie) {
      removeSessionAndLocalStorage(widgetConfigId);

      Cookies.set(
        cookieName,
        s360ConfigService.config?.isCurrentWorkingHour === true
          ? "true"
          : "false",
        {
          expires: 30,
          secure: true,
          sameSite: "None",
        }
      );
    }
  };
  useEffect(() => {
    if (
      s360ConfigService?.config &&
      s360ConfigService?.config?.anonymous &&
      !s360ConfigService?.config?.connectToNextiva
    ) {
      handleWidgetConfigCookie(s360ConfigService?.config?.widgetconfigId);
    }

    handleWidgetOfflineHours(s360ConfigService?.config?.widgetconfigId);
    if (s360ConfigService.config.preview) {
      removeAllCookies();
      removeSessionAndLocalStorage();
    }
  }, [s360ConfigService?.config]);

  // useEffect(() => {
  //   const statsigClient = initializeStatsig(
  //     "LOCAL_TEST_USER", // widgetconfig id
  //     "demo.dev.nextiva.io", // tenant url
  //     "localhostTenant" // tenant
  //   );
  //   globalFeatureFlagPollingService.initiatePolling(statsigClient);
  // }, []);

  return (
    <NetworkStatusProvider>
      <PrimaryIdentificationProvider>
        <div ref={appRef} id="App">
          {isConfigLoaded && (
            <Simplify360Chat
              removeAllCookies={removeAllCookies}
              showDynamicForm={showDynamicForm}
              chatMaximized={chatMaximized}
              refresh={refresh}
            />
          )}
        </div>
      </PrimaryIdentificationProvider>
    </NetworkStatusProvider>
  );
}

export default App;
